<template>
  <div id="calendly-booking" class="calendly-inline-widget" style="min-width:300px; height:700px;"></div>
</template>

<script setup>
const userStore = useUserStore()
const { userCountry } = storeToRefs(userStore)
const consentCountries = ['US', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'UK', 'IS', 'LI', 'NO', 'CH']

onMounted(() => {
  let calendlyUrl = 'https://calendly.com/initial-scoping-team/scoping-discussion?primary_color=096b72&hide_gdpr_banner=1'
  window.Calendly.initInlineWidget({
    url: calendlyUrl,
    parentElement: document.getElementById('calendly-booking')
  })
})
</script>